import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";

export type OperatingSystemPlatform = "mac" | "windows";

type OperatingSystemContext = {
  platform: OperatingSystemPlatform;
};

type OperatingSystemContextProviderProps = {
  platform: OperatingSystemPlatform;
  children: ReactNode;
};

const Context = createContext<OperatingSystemContext | null>(null);

export const OperatingSystemContextProvider = ({
  platform,
  children,
}: OperatingSystemContextProviderProps) => {
  const value = useMemo(() => ({ platform }), [platform]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

const throwIfNoProvider = () => {
  throw new Error("Please wrap your application in an OperatingSystemContextProvider.");
};

export const useOperatingSystem = () => {
  const { platform } = useContext(Context) ?? throwIfNoProvider();
  return { platform };
};
